import { DSP_BACKOFFICE_URL } from 'config/app'

export const DSP_BACKOFFICE_ORDER_PATH_DEFAULT =
  '/transaction-management/order-management/{orderId}'

/**
 * Builds the external DSP (Light) back-office order URL.
 * Example: https://admin.light.uat.fairprice.com.sg/transaction-management/order-management/2001178529459301
 *
 * Prefer childOrderId (the id Light's back office addresses orders by), then
 * referenceNumber (DSP sales order id), then the numeric picking-service orderId.
 * Path template is configurable via REACT_APP_DSP_BACKOFFICE_ORDER_PATH.
 */
export const buildDspBackOfficeUrl = (orderOrId) => {
  const orderId =
    orderOrId && typeof orderOrId === 'object'
      ? orderOrId.childOrderId || orderOrId.referenceNumber || orderOrId.orderId
      : orderOrId

  if (
    !DSP_BACKOFFICE_URL ||
    orderId === undefined ||
    orderId === null ||
    orderId === ''
  ) {
    return null
  }

  const base = DSP_BACKOFFICE_URL.replace(/\/$/, '')
  const pathTemplate =
    process.env.REACT_APP_DSP_BACKOFFICE_ORDER_PATH ||
    DSP_BACKOFFICE_ORDER_PATH_DEFAULT
  const path = pathTemplate.replace(
    '{orderId}',
    encodeURIComponent(String(orderId))
  )
  return `${base}${path.startsWith('/') ? path : `/${path}`}`
}

export default buildDspBackOfficeUrl
